<script lang="ts">
  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import type { RecruitmentService } from "../../services/recruitment.service";

  export let service: RecruitmentService;
  export let klass = "";
  const model = service.store.model;
</script>

<div class={klass}>
  <FormWithLabel
    label="メモ"
    input={service.handleMemo}
    value={$model.memo}
    inputType="textarea"
  />
</div>
